var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, Paper, Typography, Collapse, IconButton } from "@mui/material";
import { theme } from "@sequentech/ui-essentials";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
export var getToday = function () {
    var date = new Date();
    var diffMinutes = date.getTimezoneOffset();
    date.setHours(-Math.floor(diffMinutes / 60), -diffMinutes % 60, 0, 0);
    return date;
};
export function daysBefore(date, days) {
    var before = new Date(date);
    before.setDate(before.getDate() - days);
    return before;
}
export var formatDate = function (date) {
    return date.toISOString().substring(0, 4 + 3 + 3);
};
export function getWeekLegend(date) {
    var legend = ["M", "T", "W", "T", "F", "S", "S"];
    var dayOfWeek = date.getDay(); // 0-6 day of week
    return __spreadArray(__spreadArray([], legend.slice(dayOfWeek, 7), true), legend.slice(0, dayOfWeek), true);
}
export var StyledPaper = styled(Paper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 16px;\n"], ["\n    padding: 16px;\n"])));
export var Separator = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    margin: 16px 0;\n"], ["\n    border-top: 1px solid ", ";\n    margin: 16px 0;\n"])), theme.palette.customGrey.light);
export var ExpandIcon = styled(IconButton, {
    shouldForwardProp: function (prop) { return prop !== "expanded"; },
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    transform: ", ";\n    transition: transform 0.3s;\n    padding: 4px;\n    margin-left: auto;\n"], ["\n    transform: ", ";\n    transition: transform 0.3s;\n    padding: 4px;\n    margin-left: auto;\n"])), function (props) { return (props.expanded ? "rotate(180deg)" : "rotate(0deg)"); });
export default function CardChart(_a) {
    var title = _a.title, children = _a.children, _b = _a.collapsible, collapsible = _b === void 0 ? false : _b, actions = _a.actions;
    var _c = useState(true), expanded = _c[0], setExpanded = _c[1];
    var handleExpandClick = function () {
        if (collapsible) {
            setExpanded(!expanded);
        }
    };
    return (_jsxs(StyledPaper, { children: [_jsxs(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    cursor: collapsible ? "pointer" : "default",
                }, onClick: handleExpandClick, children: [_jsx(Typography, { fontSize: "16px", sx: { marginBottom: 0 }, color: theme.palette.customGrey.main, children: title }), actions && (_jsx(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "auto",
                        }, onClick: function (event) { return event.stopPropagation(); }, children: actions })), collapsible && (_jsx(ExpandIcon, { expanded: expanded, size: "small", children: _jsx(ExpandMoreIcon, {}) }))] }), _jsxs(Collapse, { in: expanded, timeout: "auto", unmountOnExit: true, children: [_jsx(Separator, {}), children] })] }));
}
var templateObject_1, templateObject_2, templateObject_3;
